import { FirebaseOptions } from 'firebase/app';

export function firebaseConfig(
  additionalAuthDomains: Set<string> = new Set()
): FirebaseOptions {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: additionalAuthDomains.has(window.location.hostname)
      ? window.location.hostname
      : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };
}
